<section
    class="section"
    [class.section--highlighted]="highlight"
>
    @if (title) {
        <h2
            class="section__title"
        >
            {{ title }}
        </h2>
    }

    @if (isList) {
        <ul class="section__list">
            <ng-container *ngTemplateOutlet="Content"/>
        </ul>
    } @else {
        <ng-container *ngTemplateOutlet="Content"/>
    }

    <ng-template #Content>
        <ng-content/>
    </ng-template>
</section>
